var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"goods"},[_c('div',{staticClass:"goods-left"},[_c('img',{attrs:{"src":_vm.img}}),_c('span')]),_c('div',{staticClass:"goods-right"},[_c('h3',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._v(" "+_vm._s(_vm.text))]),_c('div',[_c('span',[_vm._v("首付价格:  "),_c('b',[_vm._v("¥"+_vm._s(_vm.price))])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }